export const DEFAULT = {
  embedUrl:
    "https://www.smh.com.au/interactive/2021/political-monitor/index.html?resizable=true&configUrl=",
  formData: {
    name: undefined,
    title: undefined,
    politicalRegion: "federal"
  }
};

export const DESCRIPTION = {
  ICON: "For an example, an organisation's logo or a flag."
};

export const INSTRUCTIONS = [
  "The ‘Resolve Political Monitor’ (RPM) widget displays a single topic question in the region of interest into your story."
];

export const TABS = ["Config tool", "Saved"];

export const DUMMY_CURRENT_QUESTIONS_LIST = {
  updated: "2021-03-24T06:12:11.533Z",
  sections: [
    {
      questionSheet: "Q19",
      visual: "two group preffered bar",
      question: "Preferred PM?",
      measures: "Scott Morrison, Undecided, Anthony Albanese",
      labels: null,
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: null
    },
    {
      questionSheet: "Q15",
      visual: "ad hoc general",
      question:
        'How would you rate <span style="color:#0187D0;">Scott Morrison</span>\u2019s performance as Prime Minister in recent weeks?',
      measures: "Very good, Good, Poor, Very poor, Undecided",
      labels: "Scott Morrison",
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: " #0187D0"
    },
    {
      questionSheet: "Q17",
      visual: "ad hoc general",
      question:
        'How would you rate <span style="color:#D0011B;">Anthony Albanese</span>\u2019s performance as Opposition Leader in recent weeks?',
      measures: "Very good, Good, Poor, Very poor, Undecided",
      labels: "Anthony Albanese",
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: "#D0011B"
    },
    {
      questionSheet: "Q27NSW",
      visual: "yes no bar / Q25NSW",
      question: "How firm are you with your vote?",
      measures: "Total soft, Total hard",
      labels: "Committed, Uncommitted",
      regions: "NSW",
      colors: null
    },
    {
      questionSheet: "Q28NSW",
      visual: "two group preffered bar",
      question: "Preferred NSW Primier",
      measures: "Gladys Berejiklian, Undecided, Jodi Mackay",
      labels: null,
      regions: "NSW",
      colors: null
    }
  ]
};

export const DUMMY_WIDGET_QUESTIONS_LIST = {
  updated: "2021-03-24T06:12:11.533Z",
  sections: [
    {
      questionSheet: "Q11",
      visual: "well being index",
      question: "Wellbeing index",
      measures: null,
      labels: null,
      regions: "National, NSW, Vic",
      colors: null
    },
    {
      questionSheet: "Q5",
      visual: "detail bar and timeseries chart",
      question: "Who are you most likley to vote for?",
      measures: "ALP, LNP, GRN, ONP, IND, OTH",
      labels: null,
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: "#D0011B, #0187D0, #A9D345, #FF8B00,  #707070, #192646"
    },
    {
      questionSheet: "Q19",
      visual: "two group preffered bar",
      question: "Preferred PM?",
      measures: "Scott Morrison, Undecided, Anthony Albanese",
      labels: null,
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: null
    },
    {
      questionSheet: "Q15",
      visual: "ad hoc general",
      question:
        'How would you rate <span style="color:#0187D0;">Scott Morrison</span>\u2019s performance as Prime Minister in recent weeks?',
      measures: "Very good, Good, Poor, Very poor, Undecided",
      labels: "Scott Morrison",
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: " #0187D0"
    },
    {
      questionSheet: "Q17",
      visual: "ad hoc general",
      question:
        'How would you rate <span style="color:#D0011B;">Anthony Albanese</span>\u2019s performance as Opposition Leader in recent weeks?',
      measures: "Very good, Good, Poor, Very poor, Undecided",
      labels: "Anthony Albanese",
      regions: "National, NSW, Vic, Qld, WA, Rest of Australia",
      colors: "#D0011B"
    },
    {
      questionSheet: "Q27NSW",
      visual: "yes no bar / Q25NSW",
      question: "How firm are you with your vote?",
      measures: "Total soft, Total hard",
      labels: "Committed, Uncommitted",
      regions: "NSW",
      colors: null
    },
    {
      questionSheet: "Q28NSW",
      visual: "two group preffered bar",
      question: "Preferred NSW Primier",
      measures: "Gladys Berejiklian, Undecided, Jodi Mackay",
      labels: null,
      regions: "NSW",
      colors: null
    }
  ]
};

export default {
  DEFAULT,
  DESCRIPTION,
  INSTRUCTIONS,
  TABS,
  DUMMY_CURRENT_QUESTIONS_LIST,
  DUMMY_WIDGET_QUESTIONS_LIST
};
